<div class="container">
  <div class="row align-items-center login-font flex-res r-form">
    @if(!showSuccess){
    <div class="col-md-5 center_page">
      <div class="card px-50">
        <div class="">
          <div class="register-form">
            <div class="px-0 pt-5 mb-4">
              <p class="text-center">
                <img alt="" class="r_image" src="assets/images/favicon/CClogoFINAL-02 1.png" />
              </p>
              <p class="mt-10 user-title fs-23">Forgot Password</p>
              <p class="txt-regular">
                Enter your email and we’ll send you a link to reset your
                password.
              </p>
              <div class="col-lg-12 mt-20">
                <div class="">
                  <form [formGroup]="forgotForm" (ngSubmit)="sendResetLink()">
                    <label for="email" id="email_label">Email</label>
                    <input type="text" id="email" aria-labelledby="email_label"
                      class="form-control input-sm  chat-input" formControlName="email" placeholder="Email" />
                    @if(formErrorType === 'invalid'){
                    <div class="text-danger fs-12 mt-10">
                      Please enter a valid email
                    </div>
                    }
                    <div class="mt-15 captcha">
                      <re-captcha #captchaRef="reCaptcha" siteKey="6Ld68kEqAAAAAOfprgT6M9L8wKoCrO_fB72Ua4E8"
                        (resolved)="onCaptchaResolved($event)"></re-captcha>
                    </div>

                    <div class="mt-15">
                      <button type="submit" aria-label="Login" [disabled]="!captchaVerified"
                        class="btn w-100 cc_p_btn fs_13">
                        Send link
                      </button>
                    </div>
                    <p class="clr-grey-3 txt-regular fs-16 c-p mt-20 text-center">
                      Or
                      <a role="button" aria-label="Login" href="/login"
                        class="text-regular-medium fs-16 clr-cc-vilot u_l c-p" appFocus appClick>
                        Login</a>
                    </p>
                    <!-- ...rest of your HTML... -->
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }@else if(showSuccess) {
    <div class="col-md-5 center_page_">
      <div class="success-message">
        <div class="card px-50">
          <div class="">
            <div class="register-form text-center">
              <div class="px-0 pt-5 mb-4">
                <p class="text-center">
                  <img alt="" class="r_image" src="assets/images/side-nav/cc_original@2x.png" />
                </p>
                <p class="mt-30 user-title fs-23">Check your email</p>
                <p class="txt-regular">
                  We've sent you a link at {{ email }} that will allow for you
                  to reset your password
                </p>
                <div class="col-lg-12 mt-50 mb-50">
                  <div class="">
                    <img alt="" class="check_email_logo" src="assets/images/side-nav/check_email.png" />
                  </div>
                </div>
                <div class="col-lg-12 mt-20">
                  <div class="d-flex justify-content-center gap-5">
                    <div>
                      <a target="_blank" href="https://mail.google.com" class="txt-regular"><img alt=""
                          class="mail_logo" src="assets/images/side-nav/gmailLogo.svg" />
                        Open Gmail</a>
                    </div>
                    <div>
                      <a target="_blank" href="https://outlook.live.com" class="txt-regular">
                        <img alt="" class="mail_logo" src="assets/images/side-nav/outlookLogo.svg" />
                        Open Outlook</a>
                    </div>
                  </div>
                </div>
                <p class="txt-regular mt-20">
                  Can’t find your code? Check your spam folder!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>